import { render, staticRenderFns } from "./NewGateModal.vue?vue&type=template&id=0a8b4cf9&"
import script from "./NewGateModal.vue?vue&type=script&lang=js&"
export * from "./NewGateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports